import type { PropsWithChildren } from 'react';
import reactNodeToString from 'react-node-to-string';

import { AutoAwesomeRounded } from '@mui/icons-material';

import { Or2Chip } from '@/components/data-display/Or2Chip';

interface Props extends PropsWithChildren {
  loading: boolean;
  onClick: (question: string) => void;
}

export const AssistantSuggestedQuestionChip = ({
  children,
  loading,
  onClick,
}: Props) => {
  const question = reactNodeToString(children);
  return (
    <Or2Chip
      label={children}
      disabled={loading}
      variant="outlined"
      icon={<AutoAwesomeRounded color="primary" />}
      sx={{
        paddingY: 1,
        height: 'auto',
        '& .MuiChip-label': {
          display: 'block',
          whiteSpace: 'normal',
        },
      }}
      onClick={() => {
        onClick(question);
      }}
    />
  );
};
